import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { API } from '../api';
import { useIdioma } from '../context/LanguageContext';
import { useTranslation, Trans } from 'react-i18next';
import ChangePasswordModal from '../components/client/ChangePasswordModal';
import NormativaModal from '../components/client/NormativaModal';
import HistorialCambios from '../components/client/HistorialCambios';
import ClientSectionHeader from '../components/client/ClientSectionHeader';
import './miPerfil.css';
import CambiarTarjetaModal from '../components/canal/CambiarTarjetaModal';

/**
 * Mi Perfil — canal cliente. Maqueta "Opción C" de Ann: tarjeta de identidad (hero)
 * + acordeón con todas las secciones. Teal DE MARCA (no esmeralda).
 * CONECTADO (dato real): nombre/email/tel/sede, foto, Normativa, contraseña, historial.
 * NO conectado: se muestra la sección pero SIN inventar datos ("—"/pendiente Guardián),
 * a la espera de endpoint (mismo criterio que "bonificaciones = 0, ya lo conectaremos").
 */

/* Iconos en línea (maqueta), trazo currentColor. */
const I = {
  arrow: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M19 12H5"/><path d="m12 19-7-7 7-7"/></svg>,
  logout: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><path d="m16 17 5-5-5-5"/><path d="M21 12H9"/></svg>,
  user: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="8" r="4"/><path d="M6 21v-1a6 6 0 0 1 12 0v1"/></svg>,
  chev: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 18l6-6-6-6"/></svg>,
  bag: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>,
  trend: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 3v18h18"/><path d="m19 9-5 5-4-4-3 3"/></svg>,
  bell: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9"/><path d="M10 21a2 2 0 0 0 4 0"/></svg>,
  card: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="2" y="5" width="20" height="14" rx="2"/><path d="M2 10h20"/></svg>,
  doc: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6"/></svg>,
  shield: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="m9 12 2 2 4-4"/></svg>,
  chat: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>,
  lock: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>,
  clock: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 3v5h5"/><path d="M3.05 13A9 9 0 1 0 6 5.3L3 8"/><path d="M12 7v5l4 2"/></svg>,
  check: <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20 6 9 17l-5-5"/></svg>,
  calendar: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/></svg>,
  play: <svg viewBox="0 0 24 24" fill="currentColor" stroke="none"><path d="M8 5v14l11-7z"/></svg>,
  heart: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.29 1.51 4.04 3 5.5l7 7Z"/></svg>,
  pin: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0z"/><circle cx="12" cy="10" r="3"/></svg>,
  phone: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.94.36 1.86.7 2.73a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.35-1.35a2 2 0 0 1 2.11-.45c.87.34 1.79.57 2.73.7A2 2 0 0 1 22 16.92z"/></svg>,
  wa: <svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2a10 10 0 0 0-8.6 15l-1.4 5 5.1-1.3A10 10 0 1 0 12 2m0 2a8 8 0 1 1-4.2 14.8l-.3-.2-3 .8.8-2.9-.2-.3A8 8 0 0 1 12 4m-2.7 3.7c-.2 0-.5 0-.7.3-.2.3-.9.9-.9 2.1s.9 2.4 1 2.6c.1.2 1.7 2.8 4.3 3.8 2.1.8 2.6.7 3 .6.5 0 1.5-.6 1.7-1.2.2-.6.2-1.1.1-1.2 0-.1-.2-.2-.5-.3l-1.6-.8c-.2-.1-.4-.1-.6.1l-.7.9c-.1.2-.3.2-.5.1-.3-.1-1.1-.4-2-1.2-.7-.6-1.2-1.4-1.4-1.7-.1-.2 0-.4.1-.5l.4-.5c.1-.2.2-.3.3-.5 0-.2 0-.3 0-.5l-.8-1.8c-.2-.5-.4-.4-.5-.4z"/></svg>,
  globe: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><path d="M2 12h20"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>,
};

// Gestión de la suscripción de la WEB (WordPress/UMP · Club y Premium). Fase 1 del
// fleco de lanzamiento (Ann 2026-07-13): ENLACES a my-account, sin duplicar cobros en
// el CRM. Las 3 URLs confirmadas por Ann. En Fase 2 (membership propio) esta gestión
// se traerá entera al CRM.

// Acordeón: cabecera clicable + cuerpo. `stop` evita que un clic dentro cierre la sección.
// `locked`: sección aún no terminada (Ann 2026-07-13) → cabecera bloqueada, no se abre,
// candado + "En preparación"; no se pinta el cuerpo (nada a medias de cara al cliente).
const Acc = ({ id, icon, title, sub, open, onToggle, children, locked = false, lockedLabel = 'En preparación' }) => (
  <div className={`mp-acc${open && !locked ? ' open' : ''}${locked ? ' locked' : ''}`}>
    <button type="button" className="mp-acc-h" onClick={() => !locked && onToggle(id)}
      disabled={locked} aria-disabled={locked}>
      <span className="mp-acc-ic">{icon}</span>
      <span className="mp-acc-t">{title}<small>{locked ? lockedLabel : sub}</small></span>
      <span className="mp-acc-x">{locked ? I.lock : I.chev}</span>
    </button>
    {open && !locked && (
      <div className="mp-acc-b" onClick={(e) => e.stopPropagation()}>{children}</div>
    )}
  </div>
);

const MiPerfil = ({ user, onBack, onLogout }) => {
  // i18n zona cliente (encargo interior CA): namespace miperfil
  const { t } = useTranslation('miperfil');
  const [open, setOpen] = useState({ datos: true });
  const [showPass, setShowPass] = useState(false);
  const [showNormativa, setShowNormativa] = useState(false);
  // Ficha REAL del cliente (Ann 2026-07-13): el prop `user` es el del login (campos
  // ── SU TARJETA ────────────────────────────────────────────────────────────
  // Ann (05-10-2026): «¿podemos hacer que lo pueda cambiar ella misma desde su
  // panel en el canal?». Antes no habia NINGUN sitio donde hacerlo — ni aqui ni
  // en WordPress— y aun asi se le avisaba de que la tarjeta caducaba.
  // El numero NO pasa por nuestro servidor: el boton abre el PORTAL DE STRIPE.
  const [tarjeta, setTarjeta] = React.useState(null);
  const [abriendoPortal, setAbriendoPortal] = React.useState(false);
  // Ann (06-10-2026): «que no tenga que saltar a Stripe» · «es muy ordenado asi
  // sin salir del canal». Si hay clave publica configurada, el cambio se hace
  // AQUI DENTRO (formulario de Stripe incrustado). Si no la hay, el boton sigue
  // llevando al portal de Stripe, que es lo que ya estaba en produccion: la
  // clienta NUNCA se queda sin forma de cambiar su tarjeta.
  const [dentroDelCanal, setDentroDelCanal] = React.useState(false);
  const [modalTarjeta, setModalTarjeta] = React.useState(false);
  React.useEffect(() => {
    axios.get(`${API}/canal/mi-tarjeta`)
      .then(r => setTarjeta(r.data || null))
      .catch(() => setTarjeta(null));
    axios.get(`${API}/canal/mi-tarjeta/config`)
      .then(r => setDentroDelCanal(r.data?.disponible === true))
      .catch(() => setDentroDelCanal(false));
  }, []);

  const abrirPortalTarjeta = async () => {
    setAbriendoPortal(true);
    try {
      const r = await axios.post(`${API}/canal/mi-tarjeta/portal`);
      if (r.data?.disponible && r.data?.url) {
        window.location.href = r.data.url;
        return;
      }
      // NO se deja a la clienta mirando un boton que no hace nada: se le dice
      // que escriba, que es la salida que si existe.
      toast.error(t('productos.tarjetaNoDisponible'));
    } catch {
      toast.error(t('productos.tarjetaNoDisponible'));
    } finally {
      setAbriendoPortal(false);
    }
  };

  // limitados). Los datos completos (dirección, DNI, fecha nac., cuota, membresía…) viven
  // en /client/mi-perfil. Antes Mi Perfil no lo llamaba → campos en "—" (parecía desconectado).
  const [perfil, setPerfil] = useState(null);
  // Idioma preferido del cliente ('es' | 'ca'). Se lee de la ficha real; default 'es'.
  const [idioma, setIdioma] = useState('es');
  const [idiomaGuardando, setIdiomaGuardando] = useState(false);
  const { cambiarIdioma: aplicarIdiomaVivo } = useIdioma(); // F0 i18n: cambio en vivo
  useEffect(() => {
    axios.get(`${API}/client/mi-perfil`)
      .then(r => {
        setPerfil(r.data || null);
        const val = r.data?.personal?.idioma_preferido;
        if (val === 'es' || val === 'ca') setIdioma(val);
      })
      .catch(() => {}); // sin ficha → cae al prop user (degrada, no rompe)
  }, []);

  const cambiarIdioma = async (nuevo) => {
    if (nuevo === idioma || idiomaGuardando) return;
    const anterior = idioma;
    setIdioma(nuevo);
    setIdiomaGuardando(true);
    try {
      await axios.post(`${API}/client/idioma-preferido`, { idioma_preferido: nuevo });
      // F0 i18n: además de GUARDAR la preferencia, el idioma cambia EN VIVO
      // (misma pieza que el conmutador de la cabecera; sin re-persistir la ficha).
      aplicarIdiomaVivo(nuevo, { persistirPerfil: false });
      toast.success(t('common:idioma.guardado'));
    } catch (err) {
      setIdioma(anterior); // revertir si falla
      toast.error(t('common:idioma.error_guardar'));
    } finally {
      setIdiomaGuardando(false);
    }
  };
  const p = perfil?.personal || {};
  const pres = perfil?.presenciales || {};
  const canalOnline = perfil?.canal_online || {};
  const canalPaciente = perfil?.canal_paciente || {};
  // Prefiere el valor de la ficha real; si aún no cargó, cae al prop user.
  const pick = (a, b) => (a != null && a !== '' ? a : b);

  const tieneClasesFijas = perfil
    ? !!pres.activo
    : (['fijo', 'continuo_8'].includes(user?.servicio)
        || !!user?.inscrito_clases_fijas
        || (Array.isArray(user?.turno_fijo) && user.turno_fijo.length > 0));


  const toggle = (id) => setOpen(o => ({ ...o, [id]: !o[id] }));

  // ── BAJA DE LA SUSCRIPCIÓN (Ann 2026-07-20) ────────────────────────────
  // «La baja debe ser tan fácil como el alta» (ley europea). Antes no había
  // ninguna forma de cancelar desde el Canal: la socia tenía que escribir.
  const [bajaSolicitada, setBajaSolicitada] = useState(false);
  const [cancelando, setCancelando] = useState(false);

  useEffect(() => {
    let vivo = true;
    axios.get(`${API}/canal/suscripcion/estado-baja`)
      .then(r => { if (vivo) setBajaSolicitada(!!r.data?.solicitada); })
      .catch(() => {});
    return () => { vivo = false; };
  }, []);

  // La baja se ejecuta DE VERDAD en Membership (Ann 2026-07-20: «no podemos no
  // estar conectados al 100%, hemos de mostrar las opciones reales y no
  // decorativamente»). Mismo patrón que la compra: el CRM manda al checkout de
  // Membership para pagar → y aquí a su página de cuenta para cancelar.
  // Antes de mandarla, el CRM registra la intención y avisa a la dirección, para
  // poder ayudarla si se queda a medias.
  const pedirBaja = async () => {
    if (cancelando) return;
    // 2026-09-10: ya NO se la manda a ninguna cuenta externa (la baja se completa aquí); el
    // aviso anterior prometía eso y era falso. Texto en el idioma de la clienta.
    const ok = window.confirm(t('baja.confirm'));
    if (!ok) return;
    setCancelando(true);
    try {
      const r = await axios.post(`${API}/canal/suscripcion/cancelar`);
      // Ann 2026-09-10: la baja se completa aquí. Si no se ha podido, se dice; no se la manda a
      // otra página ni se le dice «hecho» sin estarlo.
      if (r.data?.completada) {
        setBajaSolicitada(true);
        const hasta = r.data?.acceso_hasta;
        toast.success(hasta ? t('baja.hechaHasta', { hasta }) : t('baja.hecha'), { duration: 9000 });
      } else {
        toast(t('baja.noCompletada'), { duration: 10000, icon: '⏳' });
      }
    } catch (e) {
      toast.error(t('baja.error'));
    } finally {
      setCancelando(false);
    }
  };

  const nombreCompleto = [pick(p.nombre, user?.nombre), pick(p.primer_apellido, user?.primer_apellido), pick(p.segundo_apellido, user?.segundo_apellido)]
    .filter(Boolean).join(' ') || 'Cliente';
  const dash = (v) => (v == null || v === '' ? '—' : v);
  const telefono = dash(pick(p.telefono, user?.telefono || user?.movil || user?.telefono_movil));
  const centro = dash(pick(p.sede, user?.sede));
  const direccion = dash(
    [pick(p.direccion, user?.direccion), p.piso, pick(p.codigo_postal, user?.codigo_postal),
     pick(p.ciudad, user?.ciudad), p.provincia].filter(Boolean).join(', ') || null
  );
  const email = dash(pick(p.email, user?.email));
  const fechaNac = dash(pick(p.fecha_nacimiento, user?.fecha_nacimiento));
  // DNI: el backend ya lo entrega enmascarado (_mp_mask_dni). Si no hay ficha, enmascara el del login.
  const dni = p.dni || (user?.dni ? `••••${String(user.dni).slice(-4)}` : '—');

  return (
    <div className="min-h-screen pb-5" style={{ background: 'radial-gradient(130% 70% at 50% 0%,#E1F4EF 0%,#EAF6F4 55%)' }}>
      {/* Cabecera ÚNICA de sección (misma barra teal que "Clases Online") */}
      <ClientSectionHeader title={t('titulo')} subtitle={nombreCompleto} onBack={onBack} onLogout={onLogout}
        wrapClass="md:max-w-[820px] md:mx-auto md:px-[18px]" />
      <div className="mp" style={{ paddingTop: 18 }}>

        {/* MIS DATOS */}
        <Acc id="datos" icon={I.user} title={t('datos.t')} sub={t('datos.s')} open={open.datos} onToggle={toggle}>
          {/* Ann 2026-10-26: la foto de perfil la gestiona el centro; la clienta ya no la ve ni la cambia desde aquí
              (al sustituirla se perdía la anterior). La subida inicial al darse de alta sigue igual. */}
          <div className="mp-row"><span className="k">{t('datos.nombre')}</span><span className="v">{nombreCompleto}</span></div>
          <div className="mp-row"><span className="k">{t('datos.direccion')}</span><span className="v">{direccion}</span></div>
          <div className="mp-row"><span className="k">{t('datos.telefono')}</span><span className="v">{telefono}</span></div>
          <div className="mp-row"><span className="k">{t('datos.email')}</span><span className="v">{email}</span></div>
          <div className="mp-row"><span className="k">{t('datos.fechaNac')}</span><span className="v">{fechaNac}</span></div>
          <div className="mp-row"><span className="k">{t('datos.dni')}</span><span className="v">{dni}</span></div>
          <p className="mp-note">{t('datos.nota')}</p>
        </Acc>

        {/* IDIOMA (CONECTADO: self-service /client/idioma-preferido) */}
        <Acc id="idioma" icon={I.globe} title={t('idioma.t')} sub={t('idioma.s')} open={open.idioma} onToggle={toggle}>
          <p className="mp-note" style={{ marginTop: 4 }}>{t('idioma.nota')}</p>
          <div role="group" aria-label={t('idioma.aria')}
            style={{ display: 'inline-flex', gap: 0, marginTop: 10, borderRadius: 12, overflow: 'hidden', border: '1.5px solid #077069' }}>
            {[{ v: 'es', t: 'Español' }, { v: 'ca', t: 'Català' }].map((opt) => {
              const activo = idioma === opt.v;
              return (
                <button key={opt.v} type="button" onClick={() => cambiarIdioma(opt.v)}
                  disabled={idiomaGuardando} aria-pressed={activo}
                  style={{
                    padding: '10px 22px', fontSize: 14.5, fontWeight: 600, cursor: idiomaGuardando ? 'default' : 'pointer',
                    border: 'none', background: activo ? '#077069' : '#ffffff', color: activo ? '#ffffff' : '#077069',
                    transition: 'background .15s ease',
                  }}>
                  {opt.t}
                </button>
              );
            })}
          </div>
        </Acc>

        {/* MIS PRODUCTOS */}
        <Acc id="productos" icon={I.bag} title={t('productos.t')} sub={t('productos.s')} open={open.productos} onToggle={toggle}>
          {tieneClasesFijas && (
            <div className="mp-prod">
              <div className="mp-prod-h"><span className="mp-prod-ic bg-teal">{I.calendar}</span><b>{t('productos.gestorTurnos')}</b></div>
              <div className="mp-prod-row"><span className="k">{t('productos.clasesFijas')}</span><span className="v">{t('productos.activas')}</span></div>
              {Array.isArray(pres.horario) && pres.horario.length > 0 && (
                /* Horario al que está apuntada (Ann 2026-07-15): turnos reales de la ficha. */
                <div className="mp-prod-row"><span className="k">{t('productos.horario')}</span>
                  <span className="v">{pres.horario.map((h) => `${t(`productos.dias.${h.dia}`, { defaultValue: h.dia })} ${h.hora}`).join(' · ')}</span></div>
              )}
              {pres.intensidad && <div className="mp-prod-row"><span className="k">{t('productos.intensidad')}</span><span className="v">{pres.intensidad}</span></div>}
              {centro !== '—' && <div className="mp-prod-row"><span className="k">{t('productos.sede')}</span><span className="v">{centro}</span></div>}
              {pres.cuota_nombre && (() => {
                /* Cuota + descuento real EN LA MISMA fila (Ann 2026-07-15): 
                   «76 € (13% de descuento sobre 87 € · te ahorras 132 € al año)».
                   Solo si de verdad paga MENOS que la base; números calculados, nunca fijos. */
                const base = Number(pres.cuota_importe_base);
                const paga = Number(pres.cuota_importe);
                const hayDto = base > 0 && paga > 0 && base > paga;
                const pct = hayDto ? Math.round((1 - paga / base) * 100) : 0;
                const anual = hayDto ? Math.round((base - paga) * 12) : 0;
                return (
                  <div className="mp-prod-row"><span className="k">{t('facturacion.cuota')}</span>
                    <span className="v">
                      {pres.cuota_nombre}{pres.cuota_importe != null ? ` · ${pres.cuota_importe} €` : ''}
                      {hayDto && <span className="mp-dto">{t('productos.cuotaDto', { pct, base, anual })}</span>}
                    </span></div>
                );
              })()}
            </div>
          )}
          <div className="mp-prod">
            <div className="mp-prod-h"><span className="mp-prod-ic bg-cyan">{I.play}</span>
              <b>Canal Pilar Domínguez{canalOnline.membresia && canalOnline.membresia !== 'Sin membresía' ? ` ${canalOnline.membresia}` : ''}</b></div>
            <div className="mp-prod-row"><span className="k">{t('productos.canalOnline')}</span><span className="v"><span className="mp-badge">{canalOnline.activo === false ? t('productos.sinAcceso') : t('productos.activo')}</span></span></div>
            {canalOnline.membresia && canalOnline.membresia !== 'Sin membresía' && (
              <div className="mp-prod-row"><span className="k">{t('productos.membresia')}</span><span className="v">{canalOnline.membresia}</span></div>
            )}
            {tieneClasesFijas && canalOnline.activo !== false && (
              /* Premium: el canal no se cobra aparte — es un privilegio de su cuota (Ann 2026-07-15). */
              <p className="mp-prod-note">{t('productos.canalIncluidoCuota')}</p>
            )}

            {/* SU TARJETA.
                Hasta el 14-10-2026 esto era `{tarjeta?.tiene && …}`: el botón SOLO
                salía a quien YA tenía una tarjeta. Justo al revés de lo que hace
                falta — quien no tiene ninguna es quien necesita poner una, y se
                encontraba la pantalla vacía y sin salida.
                Caso medido: Tatiana Doguet paga con Link (no es una tarjeta), su
                cobro lleva fallando desde el 29-sep y no podía arreglarlo ella.
                Ahora el botón sale SIEMPRE que se le pueda guardar una tarjeta
                (`dentroDelCanal`), y cambia el texto según tenga o no. */}
            {(tarjeta?.tiene || dentroDelCanal) && (
              <>
                {!tarjeta?.tiene && (
                  <div className="mp-prod-row">
                    <span className="k">{t('productos.tarjeta')}</span>
                    <span className="v">{t('productos.tarjetaNinguna')}</span>
                  </div>
                )}
                {tarjeta?.tiene && (
                <div className="mp-prod-row">
                  <span className="k">{t('productos.tarjeta')}</span>
                  <span className="v">
                    {(tarjeta.marca ? tarjeta.marca.toUpperCase() + ' ' : '')}
                    •••• {tarjeta.ultimos4}
                    {tarjeta.caduca_mes && tarjeta.caduca_anyo
                      ? ` · ${String(tarjeta.caduca_mes).padStart(2, '0')}/${String(tarjeta.caduca_anyo).slice(-2)}`
                      : ''}
                  </span>
                </div>
                )}
                <button
                  type="button"
                  className="mp-btn-sec"
                  onClick={dentroDelCanal ? () => setModalTarjeta(true) : abrirPortalTarjeta}
                  disabled={abriendoPortal}
                >
                  {abriendoPortal
                    ? t('productos.tarjetaAbriendo')
                    : (tarjeta?.tiene ? t('productos.tarjetaCambiar') : t('productos.tarjetaAnadir'))}
                </button>
                {modalTarjeta && (
                  <CambiarTarjetaModal
                    API={API}
                    onCerrar={() => setModalTarjeta(false)}
                    onGuardada={(d) => {
                      // La fila de la tarjeta se refresca con lo que confirma
                      // Stripe: la clienta VE sus nuevos 4 digitos, no un
                      // "guardado" a ciegas.
                      setTarjeta(prev => ({ ...(prev || {}), tiene: true, marca: d.marca,
                        ultimos4: d.ultimos4, caduca_mes: d.caduca_mes, caduca_anyo: d.caduca_anyo }));
                      setModalTarjeta(false);
                      // Solo se le promete el cobro si quedo cambiado en TODAS sus
                      // suscripciones. Si alguna fallo, se le dice la verdad: la
                      // tarjeta esta guardada y la cuota la revisamos nosotros.
                      if (d.cuota_cambiada === false) toast(t('productos.tarjetaGuardadaRevisamos'), { icon: 'ℹ️' });
                      else toast.success(t('productos.tarjetaGuardada'));
                    }}
                  />
                )}
              </>
            )}
          </div>
          <div className={`mp-prod${canalPaciente.activo ? '' : ' off'}`}>
            <div className="mp-prod-h"><span className={`mp-prod-ic ${canalPaciente.activo ? 'bg-teal' : 'bg-gray'}`}>{I.heart}</span><b>{t('productos.canalPaciente')}</b>
              {!canalPaciente.activo && <span className="mp-lock">{I.lock} {t('productos.sinAcceso')}</span>}</div>
            {canalPaciente.activo
              ? <div className="mp-prod-row"><span className="k">{t('productos.canalPaciente')}</span><span className="v"><span className="mp-badge">{t('productos.activo')}</span></span></div>
              : <p className="mp-prod-note">{t('productos.notaPaciente')}</p>}
          </div>
        </Acc>

        {/* MI ACTIVIDAD (historial de cambios · informativo) */}
        {tieneClasesFijas && (
          <Acc id="actividad" icon={I.trend} title={t('cambios.t')} sub={t('cambios.s')} open={open.actividad} onToggle={toggle}>
            <HistorialCambios />
          </Acc>
        )}

        {/* PREFERENCIAS Y AVISOS — BLOQUEADA (sin terminar, Ann 2026-07-13) */}
        <Acc id="prefs" icon={I.bell} title={t('prefs.t')} sub={t('prefs.s')} open={open.prefs} onToggle={toggle} locked lockedLabel={t('enPreparacion')}>
          <div className="mp-pref"><div><div className="mp-pref-t">{t('prefs.waT')}</div><div className="mp-pref-s">{t('prefs.waS')}</div></div><span className="mp-lock">{I.lock} {t('pendiente')}</span></div>
          <div className="mp-pref"><div><div className="mp-pref-t">{t('prefs.mailT')}</div><div className="mp-pref-s">{t('prefs.mailS')}</div></div><span className="mp-lock">{I.lock} {t('pendiente')}</span></div>
          <div className="mp-pref"><div><div className="mp-pref-t">{t('prefs.recT')}</div><div className="mp-pref-s">{t('prefs.recS')}</div></div><span className="mp-lock">{I.lock} {t('pendiente')}</span></div>
          <p className="mp-note">{t('prefs.nota')}</p>
        </Acc>

        {/* FACTURACIÓN Y PAGOS — BLOQUEADA (sin terminar + datos bancarios pendientes Guardián) */}
        <Acc id="facturacion" icon={I.card} title={t('facturacion.t')} sub={t('facturacion.s')} open={open.facturacion} onToggle={toggle} locked lockedLabel={t('enPreparacion')}>
          <div className="mp-row"><span className="k">{t('facturacion.cuota')}</span><span className="v">{pres.cuota_nombre
            ? `${pres.cuota_nombre}${pres.cuota_importe != null ? ` · ${pres.cuota_importe} €` : ''}`
            : '—'}</span></div>
          <div className="mp-row"><span className="k">{t('facturacion.metodo')}</span><span className="v">—</span></div>
          <div className="mp-row"><span className="k">{t('facturacion.proximo')}</span><span className="v">—</span></div>
          <p className="mp-note">{t('facturacion.nota')}</p>
        </Acc>

        {/* [Ann 2026-10-23] WordPress cerrado: la suscripción se gestiona en «Mi tarjeta» (portal de Stripe). */}

        {/* DOCUMENTACIÓN */}
        <Acc id="docs" icon={I.doc} title={t('docs.t')} sub={t('docs.s')} open={open.docs} onToggle={toggle}>
          <div className="mp-doc">
            <div><div className="mp-doc-t">{t('docs.normativa')}</div>
              <div className={`mp-doc-ok${user?.normativa_aceptada_fecha ? '' : ' pend'}`}>
                {user?.normativa_aceptada_fecha ? <>{I.check} {t('docs.aceptadaEl', { fecha: user.normativa_aceptada_fecha })}</> : t('docs.consulta')}
              </div></div>
            <button className="mp-mini" onClick={() => setShowNormativa(true)}>{t('ver')}</button>
          </div>
          <div className="mp-doc">
            <div><div className="mp-doc-t">{t('docs.condiciones')}</div>
              <div className={`mp-doc-ok${user?.condiciones_aceptada_fecha ? '' : ' pend'}`}>
                {user?.condiciones_aceptada_fecha ? <>{I.check} {t('docs.aceptadasEl', { fecha: user.condiciones_aceptada_fecha })}</> : t('docs.incluidas')}
              </div></div>
            <button className="mp-mini" onClick={() => setShowNormativa(true)}>{t('ver')}</button>
          </div>
        </Acc>

        {/* CONSENTIMIENTOS RGPD — BLOQUEADA (sin terminar + pendiente Guardián) */}
        <Acc id="consent" icon={I.shield} title={t('consent.t')} sub={t('consent.s')} open={open.consent} onToggle={toggle} locked lockedLabel={t('enPreparacion')}>
          <div className="mp-pref"><div><div className="mp-pref-t">{t('consent.imagenT')}</div><div className="mp-pref-s">{t('consent.imagenS')}</div></div><span className="mp-lock">{I.lock} {t('pendiente')}</span></div>
          <div className="mp-pref"><div><div className="mp-pref-t">{t('consent.comT')}</div><div className="mp-pref-s">{t('consent.comS')}</div></div><span className="mp-lock">{I.lock} {t('pendiente')}</span></div>
          <p className="mp-note">{t('consent.nota')}</p>
        </Acc>

        {/* AYUDA Y CONTACTO — BLOQUEADA (sin terminar, Ann 2026-07-13) */}
        <Acc id="ayuda" icon={I.chat} title={t('ayuda.t')} sub={t('ayuda.s')} open={open.ayuda} onToggle={toggle}>
          <a className="mp-help-row" href="https://wa.me/34623036731" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: 'inherit' }}>
            <span className="mp-help-ic">{I.wa}</span>
            <div><div style={{ fontWeight: 600 }}>{t('ayuda.waT')}</div>
              <div style={{ fontSize: 12.5, color: 'var(--muted)' }}>{t('ayuda.waS')}</div></div></a>
          <a className="mp-help-row" href="tel:+34934142860" style={{ textDecoration: 'none', color: 'inherit' }}>
            <span className="mp-help-ic">{I.phone}</span>
            <div><div style={{ fontWeight: 600 }}>{t('ayuda.telT')}</div>
              <div style={{ fontSize: 12.5, color: 'var(--muted)' }}>{t('ayuda.telS')}</div></div></a>
          <div className="mp-help-row"><span className="mp-help-ic">{I.pin}</span>
            <div><div style={{ fontWeight: 600 }}>C/ Muntaner, 239, Entresuelo</div>
              <div style={{ fontSize: 12.5, color: 'var(--muted)' }}>{t('ayuda.dirS')}</div></div></div>
        </Acc>

        {/* CONTRASEÑA (CONECTADO: ChangePasswordModal) */}
        <Acc id="pass" icon={I.lock} title={t('pass.t')} sub={t('pass.s')} open={open.pass} onToggle={toggle}>
          <p className="mp-note" style={{ marginTop: 14 }}>{t('pass.nota')}</p>
          <button className="mp-cta" onClick={() => setShowPass(true)}>{t('pass.cta')}</button>
        </Acc>

        {/* DARME DE BAJA DE MI SUSCRIPCIÓN · enlace discreto al final (Ann 2026-09-09: «un botón abajo…
            más escondido, no demos ideas; si lo quieren lo encontrarán»). Antes era el último de 13
            acordeones plegados. Misma baja que antes (pedirBaja → /canal/suscripcion/cancelar). */}
        <div data-testid="bloque-baja-suscripcion" style={{ marginTop: 34, marginBottom: 8, textAlign: 'center' }}>
          {bajaSolicitada ? (
            <p style={{ margin: 0, fontSize: 12.5, color: 'var(--muted)' }}>
              {t('baja.registrada')}
            </p>
          ) : (
            <button type="button" onClick={pedirBaja} disabled={cancelando}
                    data-testid="btn-cancelar-suscripcion"
                    style={{ background: 'none', border: 0, padding: 4, cursor: 'pointer',
                             fontSize: 12.5, color: 'var(--muted)', textDecoration: 'underline' }}>
              {cancelando ? t('baja.procesando') : t('baja.boton')}
            </button>
          )}
        </div>
      </div>

      {showPass && <ChangePasswordModal onClose={() => setShowPass(false)} />}
      {showNormativa && <NormativaModal isOpen={showNormativa} onClose={() => setShowNormativa(false)} user={user} />}
    </div>
  );
};

export default MiPerfil;
